import { useMemo } from "react";
import customerDebugApkUrl from "../../android/mozzo-kiosk/we-pedidos-app/build/outputs/apk/debug/we-pedidos-app-debug.apk";
import customerReleaseApkUrl from "../../android/mozzo-kiosk/we-pedidos-app/build/outputs/apk/release/we-pedidos-app-release.apk";
import { getRuntimeEnvironment } from "../../services/local/runtimeEnvironment";

const APK_FILE_NAMES = Object.freeze({
  beta: "WePedidos-Beta.apk",
  production: "WePedidos.apk",
});

export default function WePedidosAndroidLauncher({ compact = false }) {
  const launcher = useMemo(() => {
    const userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent;
    if (/MozzoWePedidos\/[\d.]+/i.test(userAgent)) return null;

    const isProduction = getRuntimeEnvironment() === "production";
    const selectedUrl = isProduction ? customerReleaseApkUrl : customerDebugApkUrl;
    return {
      url:
        selectedUrl && typeof window !== "undefined"
          ? new URL(selectedUrl, window.location.origin).toString()
          : selectedUrl,
      fileName: isProduction ? APK_FILE_NAMES.production : APK_FILE_NAMES.beta,
    };
  }, []);

  if (!launcher?.url) return null;

  return (
    <a
      className={`we-android-download${compact ? " is-compact" : ""}`}
      href={launcher.url}
      download={launcher.fileName}
      title="Descargar We! pedidos para Android"
    >
      <span aria-hidden="true">↓</span>
      <strong>{compact ? "Android" : "Descargar app Android"}</strong>
    </a>
  );
}
